// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E4E4E4; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: 'DM Sans', 'Inter', sans-serif, 'Noto Sans'; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #8D8D8D; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #8D8D8D; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.isolate {
  isolation: isolate;
}
.m-3 {
  margin: 0.75rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[47px\\] {
  height: 47px;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.w-48 {
  width: 12rem;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-full {
  width: 100%;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-x-16 {
  -moz-column-gap: 4rem;
       column-gap: 4rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-\\[\\#0082CA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#CDE6F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(205 230 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3CACA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 202 202 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7eeff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 238 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f8fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 248 252 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.p-1 {
  padding: 0.25rem;
}
.p-12 {
  padding: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.text-right {
  text-align: right;
}
.font-inter {
  font-family: Noto Sans;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.text-\\[\\#0082CA\\] {
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1));
}
.text-danger-100 {
  --tw-text-opacity: 1;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.ant-input-outlined:focus,
.ant-input-outlined:hover,
.ant-input-outlined-focused,
.ant-input-outlined:focus-within,
.ant-picker-outlined:focus,
.ant-picker-outlined:hover,
.ant-picker-outlined-focused,
.ant-picker-outlined:focus-within,
.ant-select-outlined.ant-select-focused .ant-select-selector,
.ant-select-outlined:hover .ant-select-selector {
  border-color: #d1d5db !important;
  box-shadow: none !important;
  outline: none !important;
}

.ant-input-affix-wrapper,
.ant-input-outlined {
  height: 45px;
  border-radius: 5px;
}

html,
body {
  font-family: Noto Sans !important;
}

.ant-form-item-explain,
.ant-form-item-explain-error,
.ant-form-item-explain-success,
.ant-form-item-explain-warning {
  font-family: Noto Sans !important;
}

:where(.ant-col),
:where(.ant-typography),
:where(.ant-row),
:where(.ant-select),
:where(.ant-input),
:where(.ant-btn),
:where(.ant-menu),
:where(.ant-table),
:where(.ant-segmented),
:where(.ant-select-single),
:where(.ant-select-selector),
:where(.ant-modal .ant-modal-title),
:where(.ant-layout) {
  font-family: Noto Sans !important;
}

.ant-select-item-option-selected {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 242 250 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
}

.ant-checkbox-label {
  font-family: Noto Sans !important;
}

.ant-checkbox-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
}

.ant-checkbox {
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
}

.ant-modal .ant-modal-content {
  border-radius: 5px;
}

.ant-menu-item:not(.ant-menu-item-selected) {
  --tw-text-opacity: 1 !important;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1)) !important;
}

.ant-menu-item:not(.ant-menu-item-selected):hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important;
}

.ant-menu-item-selected {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.ant-menu-item-active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 242 250 / var(--tw-bg-opacity, 1)) !important;
}

.ant-menu-item-selected,
.ant-menu-item-selected:hover,
.ant-menu-item-selected:focus,
.ant-menu-item-selected:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
}

.ant-menu .ant-menu-item-divider {
  display: none;
}

.ant-table-thead > tr > th {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity, 1)) !important;
  font-weight: 500 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1)) !important;
}

.ant-table-cell {
  border-inline-end: none;
}

.ant-table-tbody > tr > td {
  border-inline-end: none;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  border-right-color: none;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
  border-inline-end: none !important;
}

.ant-table-wrapper table {
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.ant-table-wrapper .ant-table-container table > thead {
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}

.ant-table-pagination {
  display: flex !important;
  justify-content: center !important;
  gap: 0.5rem;
}

.ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:first-child {
  border-top-left-radius: 5px;
}

.ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:last-child {
  border-top-right-radius: 5px;
}

.ant-table-wrapper tr.ant-table-expanded-row > td {
  padding: 0px !important;
}

.ant-btn {
  border-radius: 5px;
}

.ant-carousel .slick-dots li.slick-active::after {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
}

.ant-carousel .slick-dots li button::after {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
}

.ant-carousel .slick-dots-bottom {
  margin-bottom: -30px !important;
}

.ant-tooltip .ant-tooltip-inner {
  width: 300px !important;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1));
}

.no-body-padding .no-body-padding .ant-modal-body {
  padding: 0px;
}

.ant-table-tbody > tr.ant-table-row-selected > td {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1)) !important;
}

.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
}

.ant-modal .ant-modal-header {
  margin-bottom: 0px !important;
}

.flag-wrapper-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.flag-icon-input {
  width: 1.25rem;
}

.ant-checkbox-group {
  -moz-column-gap: 0px !important;
       column-gap: 0px !important;
}

.ant-cascader-menu-item-active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(195 195 195 / var(--tw-bg-opacity, 1)) !important;
}

.inlineDivider {
  width: auto !important;
}

.ant-divider-horizontal {
  margin: 0px !important;
  margin-bottom: 1rem !important;
  padding: 0px !important;
}

.ant-spin .ant-spin-dot {
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.ant-btn-variant-outlined,
.ant-btn-variant-outlined:hover {
  border-color: #0378d1 !important;
}

.ant-input-group-addon > .ant-select > .ant-select-selector {
  border-color: transparent !important;
}

.mySelect .ant-select-selector,
.mySelect .ant-select-dropdown,
.mySelect .ant-select-item,
.mySelect .ant-select-selection-item,
.mySelect .ant-select-selection-placeholder {
  font-family: Noto Sans !important;
}

.ant-select-dropdown .ant-select-item-option-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(240 248 255 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans !important;
  font-weight: 400 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.ant-picker-cell-in-view.ant-picker-cell:hover .ant-picker-cell-inner {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 242 250 / var(--tw-bg-opacity, 1)) !important;
}

.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
}

.ant-picker-month-btn,
.ant-picker-year-btn {
  font-weight: 400 !important;
}

.ant-checkbox-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
}

.ant-checkbox {
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
}

.ant-table-pagination {
  display: flex !important;
  justify-content: center !important;
  gap: 0.5rem;
}

.ant-pagination-item-active {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.ant-pagination-item-active a {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.ant-pagination-item-link:not([disabled]) {
  --tw-border-opacity: 1;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.ant-pagination-item-link[disabled] {
  cursor: not-allowed;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important;
}

.ant-pagination.ant-pagination-mini .ant-pagination-item,
.ant-pagination .ant-pagination-prev .ant-pagination-item-link {
  border-radius: 2px;
}

.ant-select-single .ant-select-selector {
  border-radius: 5px;
}

.ant-pagination .ant-pagination-next .ant-pagination-item-link {
  border-radius: 2px !important;
}

.ant-pagination-item:not(.ant-pagination-item-active) a {
  border-radius: 2px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1 !important;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important;
}

.ant-pagination-item:not(.ant-pagination-item-active) a:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

:where(.css-dev-only-do-not-override-rda1p3).ant-checkbox {
  border-radius: 0.125rem;
}

:where(.css-dev-only-do-not-override-rda1p3).ant-checkbox .ant-checkbox-inner {
  border-radius: 0.125rem;
}

.ant-radio-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.ant-radio-wrapper:hover .ant-radio-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
}

.ant-radio-checked .ant-radio-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.ant-radio-checked .ant-radio-inner::after {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
}

.ant-radio-inner::after {
  transform: scale(0.6);
}

@media (min-width: 768px) {

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {

  .lg\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,wDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAEnB;;;;;;;;;;EAUE,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAIE;;EAAA,YAA6B;EAA7B;AAA6B;;AAK7B;;EAAA;AAAkB;;AAOlB;;;;EAAA;AAAkB;;AAgBlB;;;;;;;;;;;;;EAAA;AAAkB;;AAIlB;EAAA,6BAA2C;EAA3C,uEAA2C;EAA3C,+BAA2C;EAA3C;AAA2C;;AAI3C;EAAA,6BAAkB;EAAlB;AAAkB;;AAIlB;EAAA;AAAkB;;AAIlB;EAAA,iCAAsB;EAAtB;AAAsB;;AAItB;EAAA,kBAAiB;EAAjB;AAAiB;;AAIjB;EAAA;AAAoB;;AAIpB;EAAA,+BAAqB;EAArB;AAAqB;;AAIrB;EAAA,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,6BAA0C;EAA1C,qEAA0C;EAA1C,+BAA0C;EAA1C;AAA0C;;AAI1C;EAAA,6BAA6B;EAA7B;AAA6B;;AAO7B;;;;EAAA,6BAA8B;EAA9B;AAA8B;;AAGhC;EACE,aAAa;AACf;;AAGE;EAAA,6BAAgD;EAAhD,uEAAgD;EAAhD,2BAAgD;EAAhD,+BAAgD;EAAhD;AAAgD;;AAGlD;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAIE;;EAAA,wBAAoC;EAApC,oBAAoC;EAApC,gDAAoC;EACpC;AADoC;;AAKpC;EAAA,sCAAgD;EAAhD,uCAAgD;EAAhD,0CAAgD;EAAhD;AAAgD;;AAIhD;EAAA,sCAAuB;EAAvB;AAAuB;;AAIvB;EAAA,wBAAkC;EAAlC,kCAAkC;EAAlC;AAAkC;;AAIlC;EAAA;AAAuB;;AAIvB;EAAA;AAAuB;;AAIvB;EAAA;AAAW;;AAIX;EAAA;AAAoB;;AAIpB;EAAA,6BAAkB;EAAlB;AAAkB;;AAIlB;EAAA,6BAAoB;EAApB;AAAoB;;AAIpB;EAAA;AAAkB;;AAIlB;EAAA,uBAA0F;EAA1F,kBAA0F;EAA1F,4DAA0F;EAA1F,sBAA0F;EAA1F,eAA0F;EAA1F,gBAA0F;EAA1F,oBAA0F;EAA1F;AAA0F;;AAI1F;EAAA;AAAU;;AAIV;EAAA,6BAAyB;EAAzB;AAAyB;;AAIzB;EAAA,kBAAiB;EAAjB;AAAiB;;AAIjB;EAAA;AAAY;;AAIZ;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA;AAAU;;AAGZ;EACE,+BAA0B;OAA1B,0BAA0B;AAC5B;;AAGE;EAAA,6BAAwB;EAAxB;AAAwB;;AAIxB;EAAA;AAAc;;AAId;EAAA,sBAAsB;EAAtB,8BAAsB;EAAtB;AAAsB;;AAItB;EAAA,+BAAoB;EAApB;AAAoB;;AAGtB;;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAOE;;;;;EAAA;AAAkB;;AAIlB;EAAA,kBAAwD;EAAxD,4DAAwD;EAAxD,iCAAwD;EAAxD,2BAAwD;EAAxD,+BAAwD;EAAxD;AAAwD;;AAIxD;EAAA,6BAA6B;EAA7B;AAA6B;;AAI7B;EAAA,6BAAkB;EAAlB;AAAkB;;AAIlB;EAAA,iCAAsB;EAAtB;AAAsB;;AAKtB;;EAAA;AAAmB;;AAInB;EAAA,iCAAsB;EAAtB;AAAsB;;AAItB;EAAA,kBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,wBAAkC;EAAlC,kCAAkC;EAAlC;AAAkC;;AAIlC;EAAA,iCAAoC;EAApC,qEAAoC;EAApC,+BAAoC;EAApC;AAAoC;;AAIpC;EAAA,iCAAoC;EAApC,qEAAoC;EAApC,+BAAoC;EAApC;AAAoC;;AAIpC;EAAA,sBAA6C;EAA7C,0DAA6C;EAA7C,6BAA6C;EAA7C,qEAA6C;EAA7C,+BAA6C;EAA7C;AAA6C;;AAI7C;EAAA,mBAAuF;EAAvF,iBAAuF;EAAvF,mBAAuF;EAAvF,iCAAuF;EAAvF,uEAAuF;EAAvF,6BAAuF;EAAvF,uEAAuF;EAAvF,+BAAuF;EAAvF;AAAuF;;AAKvF;;EAAA;AAAoB;;AAIpB;EAAA;AAAoB;;AAIpB;EAAA;AAAqB;;AAIrB;EAAA,kBAAyE;EAAzE,iBAAyE;EAAzE,sBAAyE;EAAzE,4DAAyE;EAAzE,+BAAyE;EAAzE;AAAyE;;AAAzE;EAAA,kBAAyE;EAAzE;AAAyE;;AAIzE;EAAA;AAAiB;;AAIjB;EAAA;AAAiB;;AAIjB;EAAA,iCAAiC;EAAjC,uEAAiC;EAAjC,6BAAiC;EAAjC;AAAiC;;AAIjC;EAAA,iCAAsB;EAAtB;AAAsB;;AAItB;EAAA,iCAAgC;EAAhC,qEAAgC;EAAhC,6BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,6BAAkB;EAAlB;AAAkB;;AAGpB;EACE,qBAAqB;AACvB;;AA9TA;;EAAA;IAAA;EA+TA;AAAA;;AA/TA;;EAAA;IAAA,kBA+TA;IA/TA;EA+TA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.ant-input-outlined:focus,\n.ant-input-outlined:hover,\n.ant-input-outlined-focused,\n.ant-input-outlined:focus-within,\n.ant-picker-outlined:focus,\n.ant-picker-outlined:hover,\n.ant-picker-outlined-focused,\n.ant-picker-outlined:focus-within,\n.ant-select-outlined.ant-select-focused .ant-select-selector,\n.ant-select-outlined:hover .ant-select-selector {\n  border-color: #d1d5db !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.ant-input-affix-wrapper,\n.ant-input-outlined {\n  @apply h-[45px] rounded-[5px];\n}\n\nhtml,\nbody {\n  @apply !font-inter;\n}\n\n.ant-form-item-explain,\n.ant-form-item-explain-error,\n.ant-form-item-explain-success,\n.ant-form-item-explain-warning {\n  @apply !font-inter;\n}\n\n:where(.ant-col),\n:where(.ant-typography),\n:where(.ant-row),\n:where(.ant-select),\n:where(.ant-input),\n:where(.ant-btn),\n:where(.ant-menu),\n:where(.ant-table),\n:where(.ant-segmented),\n:where(.ant-select-single),\n:where(.ant-select-selector),\n:where(.ant-modal .ant-modal-title),\n:where(.ant-layout) {\n  @apply !font-inter;\n}\n\n.ant-select-item-option-selected {\n  @apply !text-primary !bg-hoverMenuItemColor;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n  @apply !bg-primary;\n}\n\n.ant-checkbox-label {\n  @apply !font-inter;\n}\n\n.ant-checkbox-inner {\n  @apply !border-primary;\n}\n\n.ant-checkbox {\n  @apply bg-primary;\n}\n\n.ant-modal .ant-modal-content {\n  @apply rounded-[5px];\n}\n\n.ant-menu-item:not(.ant-menu-item-selected) {\n  @apply !text-gray-400;\n}\n\n.ant-menu-item:not(.ant-menu-item-selected):hover {\n  @apply !text-activeMenuItemColor;\n}\n\n.ant-menu-item-selected {\n  @apply !text-white !bg-activeMenuItemColor;\n}\n\n.ant-menu-item-active {\n  @apply !bg-hoverMenuItemColor;\n}\n\n.ant-menu-item-selected,\n.ant-menu-item-selected:hover,\n.ant-menu-item-selected:focus,\n.ant-menu-item-selected:active {\n  @apply !bg-activeMenuItemColor;\n}\n\n.ant-menu .ant-menu-item-divider {\n  display: none;\n}\n\n.ant-table-thead > tr > th {\n  @apply !text-gray-600 !bg-tableGray !font-medium;\n}\n\n.ant-table-cell {\n  border-inline-end: none;\n}\n\n.ant-table-tbody > tr > td {\n  border-inline-end: none;\n}\n\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  @apply border-r-[none] text-gray-600;\n  border-inline-end: none !important;\n}\n\n.ant-table-wrapper table {\n  @apply rounded-t-[5px] rounded-b-none !important;\n}\n\n.ant-table-wrapper .ant-table-container table > thead {\n  @apply !rounded-t-[5px];\n}\n\n.ant-table-pagination {\n  @apply !flex !justify-center gap-2;\n}\n\n.ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:first-child {\n  @apply rounded-tl-[5px];\n}\n\n.ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:last-child {\n  @apply rounded-tr-[5px];\n}\n\n.ant-table-wrapper tr.ant-table-expanded-row > td {\n  @apply !p-0;\n}\n\n.ant-btn {\n  @apply rounded-[5px];\n}\n\n.ant-carousel .slick-dots li.slick-active::after {\n  @apply !bg-primary;\n}\n\n.ant-carousel .slick-dots li button::after {\n  @apply !bg-secondary;\n}\n\n.ant-carousel .slick-dots-bottom {\n  @apply !mb-[-30px];\n}\n\n.ant-tooltip .ant-tooltip-inner {\n  @apply font-dashboardMain text-dashboardSub font-inter text-danger-100 bg-white !w-[300px];\n}\n\n.no-body-padding .no-body-padding .ant-modal-body {\n  @apply p-0;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected > td {\n  @apply !bg-tableEvenRowBG;\n}\n\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\n  @apply bg-primary;\n}\n\n.ant-modal .ant-modal-header {\n  @apply !mb-0;\n}\n\n.flag-wrapper-container {\n  @apply flex items-center gap-2;\n}\n\n.flag-icon-input {\n  @apply w-5;\n}\n\n.ant-checkbox-group {\n  column-gap: 0px !important;\n}\n\n.ant-cascader-menu-item-active {\n  @apply !bg-disabledColor;\n}\n\n.inlineDivider {\n  @apply !w-auto;\n}\n\n.ant-divider-horizontal {\n  @apply !m-0 !p-0 !mb-4;\n}\n\n.ant-spin .ant-spin-dot {\n  @apply !text-primary;\n}\n\n.ant-btn-variant-outlined,\n.ant-btn-variant-outlined:hover {\n  border-color: #0378d1 !important;\n}\n\n.ant-input-group-addon > .ant-select > .ant-select-selector {\n  border-color: transparent !important;\n}\n\n.mySelect .ant-select-selector,\n.mySelect .ant-select-dropdown,\n.mySelect .ant-select-item,\n.mySelect .ant-select-selection-item,\n.mySelect .ant-select-selection-placeholder {\n  @apply !font-inter;\n}\n\n.ant-select-dropdown .ant-select-item-option-selected {\n  @apply !font-normal !text-black bg-[#f0f8ff] !font-inter;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell:hover .ant-picker-cell-inner {\n  @apply !bg-hoverMenuItemColor;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n  @apply !bg-primary;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n  @apply !border-primary;\n}\n\n.ant-picker-month-btn,\n.ant-picker-year-btn {\n  @apply !font-normal;\n}\n\n.ant-checkbox-inner {\n  @apply !border-primary;\n}\n\n.ant-checkbox {\n  @apply bg-primary;\n}\n\n.ant-table-pagination {\n  @apply !flex !justify-center gap-2;\n}\n\n.ant-pagination-item-active {\n  @apply !border-primary !text-primary;\n}\n\n.ant-pagination-item-active a {\n  @apply !border-primary !text-primary;\n}\n\n.ant-pagination-item-link:not([disabled]) {\n  @apply !text-white border-primary !bg-primary;\n}\n\n.ant-pagination-item-link[disabled] {\n  @apply border !text-gray-300 !border-gray-200 cursor-not-allowed border-solid !bg-white;\n}\n\n.ant-pagination.ant-pagination-mini .ant-pagination-item,\n.ant-pagination .ant-pagination-prev .ant-pagination-item-link {\n  @apply rounded-[2px];\n}\n\n.ant-select-single .ant-select-selector {\n  @apply rounded-[5px];\n}\n\n.ant-pagination .ant-pagination-next .ant-pagination-item-link {\n  @apply !rounded-[2px];\n}\n\n.ant-pagination-item:not(.ant-pagination-item-active) a {\n  @apply !text-gray-300 border border-gray-200 rounded-[2px] hover:bg-white;\n}\n\n:where(.css-dev-only-do-not-override-rda1p3).ant-checkbox {\n  @apply rounded-sm;\n}\n\n:where(.css-dev-only-do-not-override-rda1p3).ant-checkbox .ant-checkbox-inner {\n  @apply rounded-sm;\n}\n\n.ant-radio-inner {\n  @apply !bg-white !border-gray-200;\n}\n\n.ant-radio-wrapper:hover .ant-radio-inner {\n  @apply !border-primary;\n}\n\n.ant-radio-checked .ant-radio-inner {\n  @apply !bg-white !border-primary;\n}\n\n.ant-radio-checked .ant-radio-inner::after {\n  @apply !bg-primary;\n}\n\n.ant-radio-inner::after {\n  transform: scale(0.6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
